__turbopack_context__.v({
  "addresses": "hWCeeW_addresses",
  "columnOne": "hWCeeW_columnOne",
  "columnThree": "hWCeeW_columnThree",
  "columnTwo": "hWCeeW_columnTwo",
  "connectItem": "hWCeeW_connectItem",
  "connectWrapper": "hWCeeW_connectWrapper",
  "detailsContainer": "hWCeeW_detailsContainer",
  "detailsContent": "hWCeeW_detailsContent",
  "detailsHeading": "hWCeeW_detailsHeading",
  "extraWrapper": "hWCeeW_extraWrapper",
  "languages": "hWCeeW_languages",
  "licenseList": "hWCeeW_licenseList",
  "licenses": "hWCeeW_licenses",
  "officeHours": "hWCeeW_officeHours",
  "timeRange": "hWCeeW_timeRange",
});
